import { FT, Spine } from 'ft'

const $SPINE = 'spine.SC05'
FT.rm.addSpine($SPINE)

class BG extends Spine {
  constructor(friendCount) {
    super(FT.rm.spine($SPINE))
    this.scale.set(0.5)
    this.position.set(FT.stage.centerX, FT.stage.centerY)

    this.render(friendCount)
  }

  render(friendCount) {
    const ids = [1, 2, 3, 4, 5, 6, 7]

    // show
    ids
      .filter(i => i <= friendCount)
      .map(i => `SC05/G_0${i}`)
      .forEach(slot => {
        if (slot === 'SC05/G_01') return
        this.skeleton.setAttachment(slot, slot)
      })

    // hide
    ids
      .filter(i => i > friendCount)
      .map(i => `SC05/G_0${i}`)
      .forEach(slot => {
        if (slot === 'SC05/G_01') return
        this.skeleton.setAttachment(slot, null)
      })
  }
}

export default BG
